/**
 * Created by ronak-jain on 10/10/18.
 */

const hindi = {
  product: 'लोन प्रोडक्ट',
  contact_us: 'संपर्क करे',
  about_us: 'हमारे बारे में',
  reasons_to_choose: 'हमें चुनने के फायदे',
  tagline1: '',
  tagline2: 'आपके व्यापार का विकास असेंड उन्नति लोन के साथ',
  apply: 'आवेदन भरें',
  submit: 'दर्ज करे',
  flexible_terms: 'फ्लेक्सिबल टर्म्स',
  custom_loan: 'कस्टम लोन्स फ्लेक्सिबल पेमेंट के साथ',
  quick_disbursement: 'शीघ्र भुगतान',
  receive_loan: 'पायें लोन मात्र तीन दिनों में',
  paper_work: 'न्यूनतम कागजी कार्यवाही',
  paper_docs: 'आय दस्तावेजों के बिना भी लोन',
  customer_focused: 'कस्टमर फ्रेंडली',
  customer_service: 'पारदर्शी एवं सरल प्रक्रिया',
  data_security: 'डाटा सिक्योरिटी',
  secured_ssl: 'आपके डाटा सुरक्षा की गारंटी',
  how_it_works: 'लोन की प्रक्रिया',
  send_enquiry: 'आवेदन फॉर्म भरें',
  online_application: 'ऑनलाइन फॉर्म भरे या कॉल करें',
  quick_verification: 'तुरंत वेरिफिकेशन',
  quick_ekyc: 'आधार से शीघ्र आईडी चेक',
  upload_documents: 'दस्तावेज अपलोड करें',
  scan_documents: 'हमारे प्रतिनिधि द्वारा आपके दस्तावेज अपलोड',
  loan_sanction: 'लोन स्वीकृति',
  loan_approval: 'तुरंत लोन मंजूरी',
  application_form: 'आवेदन फॉर्म',
  name: 'नाम',
  mobile: 'मोबाइल',
  loan_amount: 'लोन अमाउंट (लाख में )',
  address: 'पता',
  go_back: 'पीछे जायें',
  for_assistance: 'सहायता के लिए',
  call: "कॉल करें",
  email: "ईमेल",
  company: "कंपनी",
  team: "टीम",
  lap: "प्रॉपर्टी लोन",
  help: "सहायता",
  privacy_policy: "गोपनीयता नीति",
  product_page_img_text:"आपकी विभिन्न आवश्यकताओं के लिए कस्टमाइज्ड लोन प्रोडक्ट ",
  product_page_title: "आपकी क्रेडिट आवश्यकताओं को निधि देने के लिए अनुकूलित ऋण",
  product_page_subtitle:"चाहे आप अपनी संपत्ति को नवीनीकृत करना चाहते हैं, एक संपत्ति खरीदना चाहते हैं या आपको केवल कामकाजी पूंजी के लिए नकदी की जरूरत है, हम आपको और आपके व्यवसाय को सफल बनाने में मदद करना चाहते हैं। असेंड कैपिटल में, हम व्यापारियों, खुदरा विक्रेताओं, आपूर्तिकर्ताओं, निर्माताओं, ट्रैवल एजेंटों, रेडियो कैब ड्राइवरों और छोटे व्यवसाय मालिकों के विभिन्न नकदी प्रवाह और क्रेडिट आवश्यकताओं को समझते हैं। इसलिए, हमने कस्टमाइज्ड लोन बनाए हैं जो लघु और दीर्घकालिक निवेश आवश्यकताओं, ऋण कार्यकाल और एसएमई-अनुकूल पुनर्भुगतान शर्तों को ध्यान में रखते हैं। हमारे ऋण पोर्टफोलियो के माध्यम से ब्राउज़ करें और क्रेडिट उत्पाद चुनें जो आपकी व्यावसायिक आवश्यकताओं के अनुरूप सर्वोत्तम है।",
  product_page_features:"विशेषताएं",
  product_page_feature1:"कस्टमाइज्ड क्रेडिट मानदंड - हमारा क्रेडिट अंडरराइटिंग सिस्टम आपके व्यापार उसके, ऑपरेशन्स और बिक्री को देखके आपके लिए सही लोन प्रोडक्ट बताता है।",
  product_page_feature2:"आसान, सुविधाजनक और त्वरित आवेदन प्रक्रिया - हमें कॉल करें या आपको व्यवसाय ऋण के लिए आवेदन करने के लिए केवल 10 मिनट और मोबाइल, लैपटॉप या टैबलेट की आवश्यकता है। एक बार आवेदन जमा करने के बाद, हमारे प्रतिनिधि आवश्यक केवाईसी दस्तावेजों को इकट्ठा करने के लिए आपके कार्यालय का दौरा करेंगे। हम आम तौर पर जमा करने से 7 दिनों के भीतर सभी आवेदनों को संसाधित करते हैं, और तुरंत धन को अपने खाते में स्थानांतरित करते हैं।",
  product_page_feature3:"त्वरित वितरण - हमारे अत्याधुनिक तकनिकी सिस्टम और डेटा संचालित क्षमताएँ शीघ्र आपकी क्रेडिट योग्यता का पता लगा लेती है जिससे हम कार्यशील पूंजी वित्त का वितरण जल्दी ही कर देते है।",
  product_page_feature4:"फ्लेक्सिबल पुनर्भुगतान नियम - हमारे फ्लेक्सिबल पुनर्भुगतान नियम आपके व्यापार के असमान नकदी प्रवाह को ध्यान में रखकर बनाये गए है ताकि कार्यशील पूंजी व्यय के समय आपके पास धन की कमी न रहे।",
  product_page_feature5:"आवश्यकता के अनुसार ऋण कार्यकाल - आप अपने व्यापार संसाधनों और उद्देश्यों के आधार पर अल्पकालिक और दीर्घकालिक व्यापार ऋण चुन सकते हैं।",
  mortgage_loan:"प्रॉपर्टी लोन",
  product_page_loan1:"लोन राशि - ₹ 3 लाख से 20 लाख पुनर्भुगतान",
  product_page_loan2:"कार्यकाल - 1 वर्ष से 7 वर्ष",
  product_page_loan3:"ब्याज दर - प्रति वर्ष 21% से 25%",
  product_page_loan4:"प्रोसेसिंग शुल्क  - 3% + GST",
  product_page_loan_requirements:"आवश्यकताएँ",
  product_page_requirements1:"व्यापार में निरंतरता - आपका व्यापार कम से कम 3 साल पुराना होना चाहिए ",
  product_page_requirements2:"3 साल की निवास और कार्यालय स्थिरता",
  product_page_requirements3:"वित्तीय दस्तावेज - पिछले 6 महीने बैंक स्टेटमेंट्स। यदि आपके पास आईटीआर नहीं है तो हमारी टीम विभिन्न प्रकार के दस्तावेज विकल्पों के लिए आपके साथ काम करेगी",
  vehicle_loan: 'व्हीकल लोन',
  vehicle_loan_desc1:"लोन राशि - ₹ 50,000 से 20 लाख पुनर्भुगतान",
  vehicle_loan_desc2:"कार्यकाल - 1 वर्ष से 7 वर्ष",
  vehicle_loan_desc3:"ब्याज दर - प्रति वर्ष 21% से 25%",
  vehicle_loan_desc4:"प्रोसेसिंग शुल्क  - 2% + GST",

}

export default hindi


// WEBPACK FOOTER //
// ./src/constants/hindi.js